{
  "_description": "Osello pricing page — single source of truth. Edit this JSON to change plan prices, limits, annual discount %, and featured plan. The live /pricing page imports this file directly.",
  "_notes": {
    "monthlyPrice": "Monthly price with no contract. Not shown on www /pricing; only the in-app plans page offers it, with \"1-year contract\" unchecked.",
    "contractMonthlyPrice": "Monthly price on a 1-year contract (12 monthly payments, auto-renews for another year). The price www /pricing shows.",
    "yearlyPrice": "Total charged once per year on annual billing. Its per-month figure (yearlyPrice / 12) is what the annual toggle shows, so keep it a multiple of 12. The annual toggle's \"Save N%\" is derived from these prices.",
    "limits.users": "Inert on paid plans — seats are unmetered (Billing::Plans::UNMETERED_LIMIT_KEYS), so a paid store's cap comes from Store::MAX_USERS, not this number. Only freePlanLimits.users is read (by Store#max_users). Kept so seat metering can be switched back on without a schema change.",
    "unlimited": "Markets every limit as unlimited: plan cards, the comparison table and the Stripe product description say \"Unlimited\" instead of the number. The limits still apply as soft caps like any paid plan (zero overage rates), and the Terms of Service say support raises them on request at no extra fee."
  },
  "featuredPlanId": "medium",
  "plans": [
    {
      "id": "small",
      "name": "Small",
      "monthlyPrice": 709,
      "contractMonthlyPrice": 499,
      "yearlyPrice": 5148,
      "limits": {
        "activeSkus": 10000,
        "monthlyGmv": 100000,
        "maxMarketplaces": 3,
        "users": 100
      },
      "overagePricing": {
        "activeSkus": {
          "rate": 0.03,
          "calculation": "$ per Active SKU"
        },
        "monthlyGmv": {
          "rate": 0.01,
          "calculation": "% of $"
        },
        "users": {
          "rate": 50,
          "calculation": "$ per user"
        },
        "maxMarketplaces": {
          "rate": 150,
          "calculation": "$ per marketplace"
        }
      }
    },
    {
      "id": "medium",
      "name": "Medium",
      "monthlyPrice": 1419,
      "contractMonthlyPrice": 999,
      "yearlyPrice": 10308,
      "limits": {
        "activeSkus": 30000,
        "monthlyGmv": 300000,
        "maxMarketplaces": 6,
        "users": 100
      },
      "overagePricing": {
        "activeSkus": {
          "rate": 0.02,
          "calculation": "$ per Active SKU"
        },
        "monthlyGmv": {
          "rate": 0.005,
          "calculation": "% of $"
        },
        "users": {
          "rate": 50,
          "calculation": "$ per user"
        },
        "maxMarketplaces": {
          "rate": 150,
          "calculation": "$ per marketplace"
        }
      }
    },
    {
      "id": "large",
      "name": "Large",
      "monthlyPrice": 2849,
      "contractMonthlyPrice": 1999,
      "yearlyPrice": 20508,
      "limits": {
        "activeSkus": 100000,
        "monthlyGmv": 1000000,
        "maxMarketplaces": 9,
        "users": 100
      },
      "overagePricing": {
        "activeSkus": {
          "rate": 0.01,
          "calculation": "$ per Active SKU"
        },
        "monthlyGmv": {
          "rate": 0.005,
          "calculation": "% of $"
        },
        "users": {
          "rate": 50,
          "calculation": "$ per user"
        },
        "maxMarketplaces": {
          "rate": 150,
          "calculation": "$ per marketplace"
        }
      }
    },
    {
      "id": "unlimited",
      "name": "Unlimited",
      "unlimited": true,
      "monthlyPrice": 5709,
      "contractMonthlyPrice": 3999,
      "yearlyPrice": 41148,
      "limits": {
        "activeSkus": 999999,
        "monthlyGmv": 9999999,
        "maxMarketplaces": 99,
        "users": 99
      },
      "overagePricing": {
        "activeSkus": {
          "rate": 0,
          "calculation": "$ per Active SKU"
        },
        "monthlyGmv": {
          "rate": 0,
          "calculation": "% of $"
        },
        "users": {
          "rate": 0,
          "calculation": "$ per user"
        },
        "maxMarketplaces": {
          "rate": 0,
          "calculation": "$ per marketplace"
        }
      }
    }
  ],
  "freePlanLimits": {
    "activeSkus": 100,
    "monthlyGmv": 1000,
    "maxMarketplaces": 1,
    "users": 10
  }
}
